import { getCookie, removeCookie } from 'common/utilities/Cookie';
import { localStorageService } from 'common/utilities/LocalStorageService';

/**
 * The name of the cm auth cookie (This should be in sync with the backend cookie name)
 */
const CmAuthCookieExpiryName = 'SAAuthExpiry';

/**
 * Gets the expiration time of the cm auth cookie
 * @returns {number} the expiration time of the cm auth cookie
 */
export function getCmAuthCookieExpiration() {
  const expiryTime = getCookie(CmAuthCookieExpiryName);
  if (!expiryTime) {
    return 0;
  }

  return new Date(expiryTime).getTime();
}

/**
 * Checks if the cm auth cookie is valid.
 * Note that CmAuthCookie can be set by the backend:
 * 1. When the user logs in to portal
 * 2. When the user onboards to CM
 * 3. When the user successfully gets MFA authenticated by frontend and fetch an auth cookie
 * 4. When the user extends the session by engaging with the page and auth cookie gets refreshed
 * @returns {boolean} true if the cm auth cookie is valid
 */
export function isCmAuthCookieValid(): boolean {
  const expiryTime = getCmAuthCookieExpiration();
  const isValid = expiryTime > Date.now();
  return isValid;
}

/**
 * Removes auth cookie expiry from the cookie
 */
export function removeCmAuthCookieExpiry() {
  removeCookie(CmAuthCookieExpiryName);
}

/**
 * Removes the session data and the auth cookie
 */
export function removeCmSessionData() {
  localStorageService.removeSessionData();
  removeCmAuthCookieExpiry();
}
